import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom'
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { CurrentCompanyContext } from '../../App.js'

import { Container } from '../layout/AppLayout.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import SensorForm from "./SensorForm.js";

import { useNotifications } from '../shared/Notifications.js'
import { useMutationClient } from '../shared/hooks.js'
import Header from "../shared/Header.js"

export default function NewSensorPage() {
  const queryClient = useQueryClient()
  const currentCompany = useContext(CurrentCompanyContext)
  const mutationClient = useMutationClient()
  const navigate = useNavigate()
  const notifications = useNotifications()

  const mutation = useMutation(data => mutationClient.post(`sensors`, { ...data, company_id: currentCompany && currentCompany.id }), {
    onSuccess: (data, variables, context) => {
      if( data.status === 200 ){
        notifications.success('Sensor creado correctamente')
        navigate(`/sensors/${data.data.result.id}`)
      }
    },
    onError: () => {
      notifications.danger('Ha ocurrido un error al crear sensor')
    }
  })

  return (
    <Container>
      <Row>
        <Header title="Nuevo Dispositivo" items={[
          { label: "Listado de dispositivos", to: "/sensors" },
            { label: "Nuevo dispositivo" },
        ]} />
      </Row>

      <Row className="mb-4">
        <div className="col-6 mb-4">
          <div className="card mb-3 shadow-sm">
            <div className="card-header">Crear dispositivo</div>
            <div className="card-body">
              <SensorForm
                sensor={{}}
                save={data => mutation.mutate(data)}
                isLoading={mutation.isLoading}
              />
            </div>
          </div>
        </div>
      </Row>
    </Container>
  )
}